document.addEventListener('DOMContentLoaded', function() {

  // HERO SLIDER
  var track = document.getElementById('heroTrack');
  if (track) {
    var slides = track.querySelectorAll('.slide');
    var dots = document.getElementById('slideDots');
    var cur = 0, timer;
    slides.forEach(function(_, i) {
      var d = document.createElement('button');
      d.className = 'slide-dot' + (i === 0 ? ' on' : '');
      d.addEventListener('click', function() { go(i); });
      dots.appendChild(d);
    });
    function go(n) {
      cur = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      dots.querySelectorAll('.slide-dot').forEach(function(d, i) { d.classList.toggle('on', i === cur); });
      reset();
    }
    function reset() { clearInterval(timer); timer = setInterval(function() { go(cur + 1); }, 5000); }
    document.getElementById('slidePrev').addEventListener('click', function() { go(cur - 1); });
    document.getElementById('slideNext').addEventListener('click', function() { go(cur + 1); });
    reset();
  }

  // EQUIPA SLIDER
  var es = document.getElementById('equipaSlider');
  if (es) {
    var eSlides = es.querySelectorAll('.equipa-slide');
    var ec = 0;
    var wrap = es.closest('.equipa-slider-wrap');

    function eGo(n) {
      ec = (n + eSlides.length) % eSlides.length;
      var offset = wrap.getBoundingClientRect().width * ec;
      es.style.transform = 'translateX(-' + offset + 'px)';
    }
    // Recalcular si cambia el ancho (rotación de pantalla, resize, etc.)
    window.addEventListener('resize', function() { eGo(ec); });

    if (wrap) {
      wrap.querySelector('.eq-prev').addEventListener('click', function() { eGo(ec - 1); });
      wrap.querySelector('.eq-next').addEventListener('click', function() { eGo(ec + 1); });
    }
    setInterval(function() { eGo(ec + 1); }, 4000);
  }

  // MOBILE MENU
  var ham = document.getElementById('hamburger');
  var nav = document.getElementById('mobileNav');
  if (ham && nav) {
    ham.addEventListener('click', function() {
      var open = nav.classList.toggle('open');
      ham.setAttribute('aria-expanded', open);
    });
  }

  // SOCIAL PROOF POPUP
  var proofs = [
    {name:'Carlos M. de Quito', action:'solicitó cotización de Freidora a Presión', time:'hace 2 minutos'},
    {name:'Restaurante El Sabor', action:'realizó un pedido de Marmita Industrial', time:'hace 5 minutos'},
    {name:'Jorge T. de Cuenca', action:'consultó sobre Campanas de Extracción', time:'hace 8 minutos'},
    {name:'Cafetería Central, Quito', action:'solicitó cotización de Cocina Industrial', time:'hace 12 minutos'},
    {name:'Hotel Plaza, Loja', action:'solicitó equipamiento completo', time:'hace 25 minutos'}
  ];
  var pi = 0;
  var popup = document.getElementById('sp-popup');
  function showProof() {
    if (!popup) return;
    var p = proofs[pi % proofs.length];
    document.getElementById('sp-name').textContent = p.name;
    document.getElementById('sp-action').textContent = p.action;
    document.getElementById('sp-time').textContent = p.time;
    popup.style.display = 'block';
    setTimeout(function() { popup.style.display = 'none'; }, 5000);
    pi++;
  }
  setTimeout(function() { showProof(); setInterval(showProof, 18000); }, 6000);

  // SCROLL ANIMATIONS
  if ('IntersectionObserver' in window) {
    var els = document.querySelectorAll('.fp-card, .cat-card, .why-card, .review-card');
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; obs.unobserve(e.target); }
      });
    }, {threshold: 0.08});
    els.forEach(function(el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .4s ease ' + (i * 0.05) + 's, transform .4s ease ' + (i * 0.05) + 's';
      obs.observe(el);
    });
  }

});

// ── CART FUNCTIONS ──────────────────────────────────────────────────────
function addToCartCard(btn, variantId) {
  btn.textContent = '⏳';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.id) {
      btn.textContent = '✓';
      setTimeout(function() { btn.textContent = '🛒'; btn.disabled = false; }, 1500);
      if (window.fbq) {
        fbq('track', 'AddToCart', {
          content_ids: [String(data.id)],
          content_type: 'product',
          value: (data.price * data.quantity) / 100,
          currency: 'USD'
        });
      }
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var counter = document.querySelector('.cart-count');
          if (counter) { counter.textContent = cart.item_count; counter.style.display = 'flex'; }
        });
    } else {
      btn.textContent = '🛒'; btn.disabled = false;
    }
  })
  .catch(function() { btn.textContent = '🛒'; btn.disabled = false; });
}

function buyNow(btn) {
  var variantId = btn.dataset.variantId;
  btn.textContent = '⏳ Agregando...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.id) {
      btn.textContent = '✓ AGREGADO';
      setTimeout(function() { btn.textContent = '🛒 COMPRAR AHORA'; btn.disabled = false; }, 1500);
      if (window.fbq) {
        fbq('track', 'AddToCart', {
          content_ids: [String(data.id)],
          content_type: 'product',
          value: (data.price * data.quantity) / 100,
          currency: 'USD'
        });
      }
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var counter = document.querySelector('.cart-count');
        if (counter) { counter.textContent = cart.item_count; counter.style.display = 'flex'; }
      });
      window.location.href = '/cart';
    } else {
      btn.textContent = '🛒 COMPRAR AHORA'; btn.disabled = false;
    }
  })
  .catch(function() { btn.textContent = '🛒 COMPRAR AHORA'; btn.disabled = false; });
}

// PRODUCT PAGE — Fictitious stock
(function() {
  var el = document.getElementById('productStockNum');
  if (!el) return;
  // Use product handle hash for consistent number
  var handle = window.location.pathname;
  var hash = 0;
  for (var i = 0; i < handle.length; i++) { hash = ((hash << 5) - hash) + handle.charCodeAt(i); hash |= 0; }
  var base = Math.abs(hash) % 48 + 7;
  var dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
  var week = Math.floor(dayOfYear / 7) % 4;
  var adj = (week * 3) - 4;
  var stock = Math.max(3, Math.min(55, base + adj));
  el.textContent = stock;
  if (stock <= 5) {
    el.parentElement.style.color = '#e53e3e';
    el.parentElement.querySelector('.product-stock-dot').style.background = '#e53e3e';
    el.parentElement.querySelector('.product-stock-dot').style.boxShadow = '0 0 0 3px rgba(229,62,62,0.2)';
  }
})();
